import { CUSTOM_VALIDATION_FIELDS, VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const DEFAULT_DIAMOND_REDIRECT_LEVEL = 23;

export const SELF_EXCLUSION_LOGIN_CODE = 'rg_selfexclude_player_login_disabled';
export const TIME_OUT_LOGIN_CODE = 'rg_timeout_player_login_disabled';
export const ACCOUNT_FROZEN = 'acl_error_frozen';
export const ACCOUNT_FROZEN_SECOND = 'frozen_username';
export const DEFAULT_SELF_EXCLUSION_LOGIN_ARTICLE = 'SELF_EXCLUSION_LOGIN_ERROR';
export const DEFAULT_RETAIL_SELF_EXCLUSION_LOGIN_ARTICLE = 'RETAIL_SELF_EXCLUSION_LOGIN_ERROR';
export const DEFAULT_TIME_OUT_LOGIN_ARTICLE = 'TIMED_OUT_LOGIN_ERROR';
export const DEFAULT_ACCOUNT_FROZEN_ARTICLE_AFTER_LOGIN = 'ACCOUNT_FROZEN__ERROR';
export const DEFAULT_ACCOUNT_FROZEN_ARTICLE_AFTER_REGISTRATION = 'ACCOUNT_FROZEN__ERROR_AFTER_REGISTRATION';
export const DATE_POSITION_LENGTH = 19;
export const DOMINANT_CARD_ERROR_CODE = 22;
export const ACCOUNT_FROZEN_ERROR_CODE = 23;
export const INCORRECT_USERNAME_OR_PASSWORD_ERROR_CODE = 2;

export const ONLY_ARTICLES_CONTENT = [ACCOUNT_FROZEN, ACCOUNT_FROZEN_SECOND];
export const WITH_LOGO_POPUPS = [ACCOUNT_FROZEN, ACCOUNT_FROZEN_SECOND];

export const SMALL_BTN_SUBMIT = 'smallBtnSubmit';
export const FAILED_LOGIN_ATTEMPTS = 'failedLoginAttempts';

export const VALIDATION_FIELDS_LOGIN = [VALIDATION_FIELDS.userName, CUSTOM_VALIDATION_FIELDS.login];
